/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AreaWaitingTimeListResponse } from '../../models/area-waiting-time-list-response';

export interface GetAllAreasWaitingTime$Params {
}

export function getAllAreasWaitingTime(http: HttpClient, rootUrl: string, params?: GetAllAreasWaitingTime$Params, context?: HttpContext): Observable<StrictHttpResponse<AreaWaitingTimeListResponse>> {
  const rb = new RequestBuilder(rootUrl, getAllAreasWaitingTime.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AreaWaitingTimeListResponse>;
    })
  );
}

getAllAreasWaitingTime.PATH = '/api/v1/areas/waiting_time';
